if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'start', inline: 'nearest' });

        if (activeMedia.nodeName !== 'DEFERRED-MEDIA' || !activeMediaContent) return;

        activeMedia.loadContent(false);
        const video = activeMedia.querySelector('video');
        if (!video) return;

        video.muted = true;
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => {});
      }
    }
  );
}
